import { PostTypes } from '../../../Utils/Types';

export default {
  [PostTypes.ARTICLE]: {
    publishingDetail: true,
  },
  [PostTypes.EVENT]: {
    eventDetail: true,
  },
  [PostTypes.IDEAS_REQUEST]: {
    consultationProgress: true,
    ideasCounter: true,
  },
  [PostTypes.PARTICIPATORY_BUDGET]: {
    consultationProgress: true,
    ideasCounter: true,
  },
  [PostTypes.COLLABORATIVE_DECISION]: {
    consultationProgress: true,
    ideasCounter: true,
  },
  [PostTypes.FOLDER]: {
    ideasCounter: false,
  },
  [PostTypes.STUDY]: {
    consultationProgress: true,
    ideasCounter: false,
  },
};
